import { render, staticRenderFns } from "./ResearchContainer.vue?vue&type=template&id=149475ed&scoped=true&"
import script from "./ResearchContainer.vue?vue&type=script&lang=js&"
export * from "./ResearchContainer.vue?vue&type=script&lang=js&"
import style0 from "./ResearchContainer.vue?vue&type=style&index=0&id=149475ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149475ed",
  null
  
)

export default component.exports